exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-item{background-repeat:no-repeat;right:0;top:0;background-size:contain}.slide-body,.slide-item{position:absolute;left:0;bottom:0}.slide-body{padding:40px 25px;background:#fff;max-width:43%}.slider__h3{margin:12px 0 0}.slider__link{font-size:14px;text-decoration:none;font-weight:700;color:#90a0af}.slider__link-title{color:#172842;text-decoration:none;font-weight:800;font-size:calc(14px + 1.25vw)}.slider__link-title:hover{color:#e2687e}.slider__author{color:#90a0af;font-size:14px;font-weight:700;text-transform:uppercase;line-height:15px;margin-top:12px}", ""]);

// exports
